import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../components/Header";
import Search from "../components/Search";
import FeaturedProperties from "../components/FeaturedProperties";
import Footer from "../components/Footer";
import React, { useContext, useEffect } from "react";
import { InfoContext } from "../providers/InfosContextProvider";
import { heroBackgroundStyle } from "../utils/images";

function Home() {
  const { texts } = useContext(InfoContext);

  useEffect(() => {
    const pageTitle =
      texts?.header?.home || texts?.header?.home || "Início";
    document.title = `${pageTitle} | Casas do Nabão`;
  }, [texts]);
  return (
    <>
      <Header />
      <div
        className="hero-background"
        style={heroBackgroundStyle}
      >
        <Search />
        <FeaturedProperties />
      </div>
      <Footer />
    </>
  );
}

export default Home;
